import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalCloseButton,
    ModalBody,
    ModalFooter,
    Button,
  } from '@chakra-ui/react';
import { dangerButtonProps, secondaryButtonProps } from '../../theme/adminUi';

  const DeleteModal = ({ isOpen, onClose, onConfirm, name, isLoading = false }) => {
    return (
      <Modal isOpen={isOpen} onClose={onClose} closeOnOverlayClick={false}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>¿Eliminar elemento?</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            ¿Estás seguro de que deseas eliminar <strong>{name}</strong>?
          </ModalBody>
          <ModalFooter>
            <Button {...secondaryButtonProps} mr={3} onClick={onClose} isDisabled={isLoading}>
              Cancelar
            </Button>
            <Button {...dangerButtonProps} onClick={onConfirm} isLoading={isLoading}>
              Eliminar
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    );
  };
  
export default DeleteModal;
